<template>
  <div class="help-view">
    <!-- <div class="pink-dec pink-dec1" />
    <div class="pink-dec pink-dec2" />
    <div class="pink-dec pink-dec3" />
    <div class="home-dec1" />
    <div class="home-dec2" /> -->
    <Banner :image-list="bannerImages" :duration="5000" />
    <div class="help-container">
      <SideMenu />
      <div class="help-content">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
    </div>
    <!-- 悬浮二维码按钮 -->
    <div class="float-qrcode-wrapper">
      <FloatQrcode />
    </div>
    <HomeFooter v-if="showFooter" />
  </div>
</template>

<script>
import Banner from '@/components/Banner/Banner.vue';
import FloatQrcode from '@/components/FloatQrcode/FloatQrcode.vue';
import HomeFooter from '@/components/HomeFooter/HomeFooter.vue';
import { mapState } from 'vuex';
import SideMenu from './SideMenu.vue';

export default {
  name: 'HelpView',
  components: {
    Banner,
    FloatQrcode,
    SideMenu,
    HomeFooter,
  },
  computed: {
    ...mapState(['bannerImages']),
    showFooter() {
      // 所有 /help 路由及其子路由都显示 footer
      const currentPath = this.$route.path;
      if (currentPath.startsWith('/help')) {
        return true;
      }
      // 其他情况检查 meta.showFooter
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.showFooter !== undefined) {
          return matched[i].meta.showFooter;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.help-view {
  position: relative;
  z-index: 0; // 创建局部层叠上下文，方便控制内部层级
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  padding-top: 62px;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;

  .pink-dec {
    position: absolute;
    z-index: 0; // 在 help-view 背景之上，但低于其他内容
    pointer-events: none; // 不影响鼠标/点击事件
    width: 589px;
    height: 588px;
    background: rgba(221, 1, 255, 1);
    filter: blur(369px);
  }

  .home-dec1 {
    position: absolute;
    z-index: 1; // 高于粉色模糊背景，但低于主体内容
    pointer-events: none;
    width: 171px;
    height: 525px;
    background: url('~@/assets/image/home-dec1.png') no-repeat center center;
    background-size: contain;
    top: 850px;
    right: 0;
  }

  .home-dec2 {
    position: absolute;
    z-index: 1;
    pointer-events: none;
    width: 291px;
    height: 850px;
    background: url('~@/assets/image/home-dec2.png') no-repeat center center;
    background-size: contain;
    top: 1350px;
    left: 0px;
  }

  .pink-dec1 {
    top: 900px;
    right: -400px;
  }

  .pink-dec2 {
    top: 1600px;
    left: -400px;
    filter: blur(469px);
  }

  .pink-dec3 {
    top: 3100px;
    right: -400px;
    filter: blur(469px);
  }

  .help-container {
    position: relative;
    z-index: 2;
    width: 1152px;
    min-height: 500px;
    margin: 22px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .help-content {
    width: 856px;
    // 子路由内容容器
  }

  // 让除粉色背景、home-dec1、home-dec2 和浮动二维码容器以外的所有直接子元素都在其之上
  >*:not(.pink-dec):not(.home-dec1):not(.home-dec2):not(.float-qrcode-wrapper) {
    position: relative;
    z-index: 2;
  }

  // 悬浮二维码按钮的外层容器，不参与内部层级控制
  .float-qrcode-wrapper {
    position: static;
    z-index: auto;
  }
}
</style>
